
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"icon-settings","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"svg-n svg-m svg-c",attrs:{"d":"M63 15H1m62 17H1m62 17H1"}}),_c('ellipse',{staticClass:"svg-b svg-c",attrs:{"cx":"14","cy":"15","rx":"6","ry":"6.06"}}),_c('ellipse',{staticClass:"svg-b svg-c",attrs:{"cx":"32","cy":"32","rx":"6","ry":"6.06"}}),_c('ellipse',{staticClass:"svg-b svg-c",attrs:{"cx":"50","cy":"49","rx":"6","ry":"6.06"}})])
          )
        }
      }
    